// printer.service.ts

import { Injectable } from '@angular/core';
import { Http, Headers,RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { URL_PRINT_GLOBAL_PORT } from '../../config/url.servicio';
@Injectable()
export class PrinterService {

  constructor(public http: Http) { }

  // Método para imprimir texto usando el servicio web
  printText(printerName: string, textToPrint: string,ip:string,cufe:string = '') {
    const payload = { printerName, textToPrint, cufe };
    let port = URL_PRINT_GLOBAL_PORT
    const headers = new Headers({ 'Content-Type': 'application/json' });

    const options = new RequestOptions({ headers: headers });
    let url = `https://${ip}:${port}`
    return this.http.post(`${url}/imprimir`, payload, options)
      .map(res => res.json());
  }
  // Método para obtener la lista de impresoras disponibles
  getPrinters(ip:string): Observable<any> {
    let port = URL_PRINT_GLOBAL_PORT
    let url = `https://${ip}:${port}`
    return this.http.get(`${url}/buscarimpresoras`)
    .map((data) => data.json())
  }

}



// WEBPACK FOOTER //
// ./src/providers/printglobal/printer.service.ts